import { useTranslation } from 'react-i18next'

const NoDataAvailableMessage = () => {
  const { t } = useTranslation('common')
  return (
    <div className="text-center">
      <h3 className="text-black font-semibold">{t('pages.home.new-user.title')} 👋</h3>
      <p className="text-gray-600 mt-2">{t('pages.home.new-user.message')}</p>
    </div>
  )
}

export default NoDataAvailableMessage
